import { preDefStr, parseTooltext, pluck, getValidValue, pluckNumber, getFirstValue, HUNDREDSTRING,
  parseUnsafeString, convertColor, getFirstAlpha, getFirstColor } from '@fusioncharts/core/src/lib';
import ColumnDataset from '@fusioncharts/charts/src/dataset/column';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import errorbarAnimation from './index.animation';

let colorStrings = preDefStr.colors,
  COLOR_AAAAAA = colorStrings.AAAAAA,
  ROUND = preDefStr.ROUND,
  MOUSEOVER = 'mouseOver',
  MOUSEOUT = 'mouseOut',
  PERCENTAGESTRING = preDefStr.PERCENTAGESTRING,
  pStr = preDefStr.pStr,
  sStr = preDefStr.sStr,
  BLANKSTRING = '',
  UNDEF,
  removePlots,
  ROLLOVER = 'DataPlotRollOver',
  ROLLOUT = 'DataPlotRollOut',
  COMMASPACE = ', ',
  // showHoverEffectStr = preDefStr.showHoverEffectStr,
  // SETROLLOVERATTR = preDefStr.setRolloverAttrStr,
  // SETROLLOUTATTR = preDefStr.setRolloutAttrStr,
  DEFAULT_CURSOR = 'default',

  POINTER = 'pointer',
  EVENTARGS = 'eventArgs',
  GROUPID = 'groupId',
  M = 'M',
  H = 'H',
  V = 'V',
  _getHoveredPlot,
  _firePlotEvent,
  _checkPointerOverPlot,
  _checkPointerOverErrorBar,
  _rolloverResponseSetter = function (chart, data, event, dataset) {
    var dataGraphics = data.graphics,
      elem = dataGraphics && dataGraphics.element,
      animationManager = chart.getFromEnv('animationManager');

    if (!data.errorBarHovered && elem && elem.getData().showHoverEffect !== 0) {
      animationManager.setAnimationState(MOUSEOVER);
      animationManager.setAnimation({
        el: elem,
        label: 'rect',
        component: dataset,
        attr: elem.getData().setRolloverAttr,
        doNotRemove: true
      });
    }
    elem && chart.plotEventHandler(elem, event, ROLLOVER);
  },
  _rolloutResponseSetter = function (chart, data, event, dataset) {
    var dataGraphics = data.graphics,
      elem = dataGraphics && dataGraphics.element,
      animationManager = chart.getFromEnv('animationManager');

    if (!data.errorBarHovered && elem && elem.getData().showHoverEffect !== 0) {
      animationManager.setAnimationState(MOUSEOUT);
      animationManager.setAnimation({
        el: elem,
        label: 'rect',
        component: dataset,
        attr: elem.getData().setRolloutAttr,
        doNotRemove: true
      });
    }
    elem && chart.plotEventHandler(elem, event, ROLLOUT);
  };
addDep({
  name: 'errorbar2DColumnAnimation',
  type: 'animationRule',
  extension: errorbarAnimation.column
});
addDep({
  name: 'errorbar2DErrorAnimation',
  type: 'animationRule',
  extension: errorbarAnimation.error
});
class ErrorBar2DDataset extends ColumnDataset {
  constructor () {
    super();
    // eslint-disable-next-line good-practices/no-function-dependency
    this.drawCallBackFn = (state) => {
      return function () {
        if (state === 'disappearing') {
          this.hide();
        } else {
          this.show();
        }
      };
    };
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'errorBar2D';
  }
  /*
   * Function for parsing all the attributes and value given by the user at chart,dataset and set level.
   * This function is called once from the init() function of the Column class.
   */
  ErrorValueConfigure () {
    var dataSet = this,
      conf = dataSet.config,
      // fcJSON = dataSet.fcJSON,
      JSONData = conf.JSONData,
      setDataArr = JSONData.data,
      chartAttr = dataSet.getFromEnv('chart-attrib'),
      setData,
      dataObj,
      config,
      dataStore = dataSet.components.data,
      toolText,
      seriesNameInTooltip = pluckNumber(chartAttr.seriesnameintooltip, 1), // eslint-disable-line good-practices/no-single-usage-variable
      seriesname,
      tooltipSepChar = parseUnsafeString(pluck(chartAttr.tooltipsepchar, COMMASPACE)),
      numberFormatter = dataSet.getFromEnv('number-formatter'),
      errorInPercent,
      macroIndices,
      parserConfig,
      toolTipValue,
      errorBarAlpha,
      setErrorValue,
      setPositiveErrorValue,
      setNegativeErrorValue,
      formatedVal,
      setTooltext,
      errorBarShadow,
      maxValue = -Infinity,
      minValue = Infinity,
      parentYAxis,
      setValue,
      errorValue,
      maxErrorValue,
      catLen = dataSet.getFromEnv('xAxis').getTicksLen(), // eslint-disable-line good-practices/no-single-usage-variable
      len = Math.min(catLen, setDataArr && setDataArr.length), // eslint-disable-line good-practices/no-single-usage-variable
      minErrorValue,
      halfErrorBar,
      positiveErrorValue,
      negativeErrorValue,
      cumulativeValueOnErrorBar,
      positiveCumulativeErrorTooltext,
      negativeCumulativeErrorTooltext,
      getTooltext = function (setToolText) {
        var tooltext;

        if (!conf.showTooltip) {
          tooltext = false;
        } else {
          if (formatedVal === null) {
            tooltext = false;
          } else if (setToolText !== UNDEF) {
            macroIndices = [1, 2, 3, 4, 5, 6, 7, 99, 100, 101, 102, 120, 121, 131, 132];
            parserConfig = {
              yaxisName: parseUnsafeString(chartAttr.yaxisname),
              xaxisName: parseUnsafeString(chartAttr.xaxisname),
              formattedValue: config.toolTipValue,
              errorValue: setErrorValue,
              errorDataValue: config.errorToolTipValue,
              errorPercentValue: config.errorPercentValue,
              errorPercentDataValue: config.errorPercentValue,
              positiveErrorValue: setPositiveErrorValue,
              negativeErrorValue: setNegativeErrorValue,
              positiveErrorDataValue: config.positiveErrorToolTipValue,
              negativeErrorDataValue: config.negativeErrorToolTipValue,
              label: config.label
            };
            tooltext = parseTooltext(setToolText, macroIndices,
              parserConfig, setData, chartAttr, JSONData);
          } else {
            if (seriesNameInTooltip) {
              seriesname = getFirstValue(JSONData && JSONData.seriesname);
            }
            tooltext = seriesname ? seriesname + tooltipSepChar : BLANKSTRING;
            tooltext += config.label ? config.label + tooltipSepChar : BLANKSTRING;
          }
        }
        return tooltext;
      },
      positiveErrorToolText,
      negativeErrorToolText,
      i;
    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.errorInPercent = errorInPercent = pluckNumber(JSONData.errorinpercent, chartAttr.errorinpercent);// eslint-disable-line good-practices/no-single-usage-variable
    conf.showValues = pluckNumber(JSONData.showvalues, chartAttr.showvalues, 0);
    conf.errorBarShadow = errorBarShadow = pluckNumber(chartAttr.errorbarshadow, chartAttr.showshadow, 1);// eslint-disable-line good-practices/no-single-usage-variable
    conf.ignoreEmptyDatasets = pluckNumber(JSONData.ignoreemptydatasets, 0);
    halfErrorBar = pluckNumber(chartAttr.halferrorbar, 1);// eslint-disable-line good-practices/no-single-usage-variable
    conf.notHalfErrorBar = !pluckNumber(chartAttr.halferrorbar, 1);

    errorBarAlpha = getFirstAlpha(pluck(
      JSONData.errorbaralpha, chartAttr.errorbaralpha, conf.plotfillalpha));
    conf.errorBarWidthPercent = pluckNumber(
      JSONData.errorbarwidthpercent, chartAttr.errorbarwidthpercent, 70);
    conf.errorBarColor = convertColor(getFirstColor(
      pluck(JSONData.errorbarcolor, chartAttr.errorbarcolor,
        COLOR_AAAAAA)), errorBarAlpha);
    conf.errorBarThickness = pluckNumber(
      JSONData.errorbarthickness, chartAttr.errorbarthickness, 1);
    conf.shadowOpacity = errorBarShadow ? (errorBarAlpha / 250) : 0;
    conf.parentYAxis =
      parentYAxis = pluck(JSONData.parentyaxis && JSONData.parentyaxis.toLowerCase(), pStr) === sStr ? 1 : 0;
    conf.cumulativeValueOnErrorBar = pluckNumber(JSONData.cumulativevalueonerrorbar, chartAttr.cumulativevalueonerrorbar, 1);
    for (i = 0; i < len; i++) {
      dataObj = dataStore[i];
      if (!dataObj) {
        continue;
      }
      setData = setDataArr && setDataArr[i];
      config = dataObj && dataObj.config;
      positiveErrorToolText = UNDEF;
      negativeErrorToolText = UNDEF;

      if (pluckNumber(setData.value) === UNDEF) {
        continue;
      }

      if (!dataObj) {
        dataObj = dataStore[i] = {
          graphics: {}
        };
      }

      if (!dataObj.config) {
        config = dataStore[i].config = {};
      }
      setValue = config.setValue;
      config.setErrorValue = setErrorValue = numberFormatter.getCleanValue(setData.errorvalue);
      config.errorInPercent = pluckNumber(setData.errorinpercent, errorInPercent, 0);
      setPositiveErrorValue = numberFormatter.getCleanValue(pluckNumber(setData.positiveerrorvalue, setErrorValue));
      setNegativeErrorValue = numberFormatter.getCleanValue(pluckNumber(setData.negativeerrorvalue, setErrorValue));

      config.errorInPercent &&
                (config.setErrorValue = setErrorValue = pluckNumber(((setErrorValue / 100) * setValue).toFixed(2)));

      config.cumulativeValueOnErrorBar =
                    pluckNumber(setData.cumulativevalueonerrorbar, conf.cumulativeValueOnErrorBar, 1);

      config.positiveErrorValue =
                    numberFormatter.getCleanValue(pluckNumber(setData.positiveerrorvalue, setData.errorvalue));

      (config.errorInPercent && config.positiveErrorValue) &&
                (config.positiveErrorValue = pluckNumber(((config.positiveErrorValue / 100) *
                    setValue).toFixed(2)));
      config.positiveCumulativeErrorValue = setValue +
                    pluckNumber(config.positiveErrorValue, config.setErrorValue);

      config.negativeErrorValue =
                    numberFormatter.getCleanValue(pluckNumber(setData.negativeerrorvalue, setData.errorvalue));

      (config.errorInPercent && config.negativeErrorValue) &&
                (config.negativeErrorValue = pluckNumber(((config.negativeErrorValue / 100) *
                    setValue).toFixed(2)));

      config.negativeCumulativeErrorValue = setValue -
                    pluckNumber(config.negativeErrorValue, config.setErrorValue);

      config.errorToolTipValue = numberFormatter.dataLabels(setErrorValue, parentYAxis);

      config.negativeErrorToolTipValue =
                    numberFormatter.dataLabels(config.negativeErrorValue, parentYAxis);

      config.negativeCumulativeErrorTooltipValue =
                    numberFormatter.dataLabels(config.negativeCumulativeErrorValue, parentYAxis);

      config.positiveErrorToolTipValue =
                    numberFormatter.dataLabels(config.positiveErrorValue, parentYAxis);

      config.positiveCumulativeErrorTooltipValue =
                    numberFormatter.dataLabels(config.positiveCumulativeErrorValue, parentYAxis);

      config.errorPercentValue =
        (Math.round(((setErrorValue / setValue) * HUNDREDSTRING) * HUNDREDSTRING) / HUNDREDSTRING) + PERCENTAGESTRING;

      cumulativeValueOnErrorBar = config.cumulativeValueOnErrorBar;

      config.notHalfErrorBar = conf.notHalfErrorBar;
      config.halfErrorBar = halfErrorBar;

      config.showValue = pluckNumber(setData.showvalue, conf.showValues);
      config.hasErrorValue = pluckNumber(setData.errorvalue) !== UNDEF ? 1 : 0;

      errorValue = config.errorValue = setErrorValue;

      toolTipValue = config.errorToolTipValue;

      formatedVal = toolTipValue;

      setTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext,
        formatedVal), false));

      toolText = getTooltext(setTooltext);

      positiveErrorToolText = negativeErrorToolText = UNDEF;

      setTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext,
        config.positiveErrorToolTipValue), false));

      (setTooltext && config.positiveErrorToolTipValue) &&
                    (positiveErrorToolText = getTooltext(setTooltext));

      setTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
        JSONData.errorplottooltext, chartAttr.errorplottooltext,
        config.negativeErrorToolTipValue), false));

      (setTooltext && config.negativeErrorToolTipValue) &&
                    (negativeErrorToolText = getTooltext(setTooltext));

      if (cumulativeValueOnErrorBar) {
        setTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
          JSONData.errorplottooltext, chartAttr.errorplottooltext,
          config.positiveCumulativeErrorTooltipValue), false));

        (setTooltext && config.positiveCumulativeErrorTooltipValue) &&
                        (positiveCumulativeErrorTooltext = getTooltext(setTooltext));

        setTooltext = getValidValue(parseUnsafeString(pluck(setData.errorplottooltext,
          JSONData.errorplottooltext, chartAttr.errorplottooltext,
          config.negativeCumulativeErrorTooltipValue), false));

        (setTooltext && config.negativeCumulativeErrorTooltipValue) &&
                        (negativeCumulativeErrorTooltext = getTooltext(setTooltext));
      }

      positiveErrorValue = config.positiveErrorValue;

      negativeErrorValue = config.negativeErrorValue;

      if (setData.positiveerrorvalue || setData.negativeerrorvalue) {
        config.halfErrorBar = 0;
        config.notHalfErrorBar = true;
      }

      maxErrorValue = setValue + (positiveErrorValue !== null ? positiveErrorValue : setErrorValue);
      minErrorValue = setValue - (config.halfErrorBar ? 0 : ((negativeErrorValue < 0 && setValue < 0) ? 0
        : (negativeErrorValue !== null ? negativeErrorValue : setErrorValue)));

      maxValue = Math.max(maxValue, maxErrorValue, minErrorValue);
      minValue = Math.min(minValue, maxErrorValue, minErrorValue);

      config.errorValueArr = [];
      (config.positiveErrorValue === null) && (config.positiveErrorValue = UNDEF);
      errorValue = -config.positiveErrorValue;
      config.errorValueArr.push({
        errorValue: errorValue,
        tooltext: cumulativeValueOnErrorBar ? positiveCumulativeErrorTooltext
          : (positiveErrorToolText || toolText),
        errorEdgeBar: true
      });

      config.errorValueArr.push({
        errorValue: errorValue,
        tooltext: positiveErrorToolText || toolText
      });

      if (config.notHalfErrorBar) {
        errorValue = config.negativeErrorValue;
        config.errorValueArr.push({
          errorValue: errorValue,
          tooltext: cumulativeValueOnErrorBar ? negativeCumulativeErrorTooltext
            : (negativeErrorToolText || toolText),
          errorEdgeBar: true
        });
        config.errorValueArr.push({
          errorValue: errorValue,
          tooltext: negativeErrorToolText || toolText
        });
      }
      config.toolText = getTooltext(config.setTooltext);
    }
    conf.maxValue = maxValue;
    conf.minValue = minValue;
  }
  drawErrorValue () {
    var dataSet = this,
      conf = dataSet.config,
      attr,
      i,
      k,
      visible = dataSet.getState('visible'),
      yAxis = dataSet.getFromEnv('yAxis'),
      errorBarThickness = conf.errorBarThickness,
      errorBarColor = conf.errorBarColor,

      setLink,
      xPos,
      yPos,

      dataObj,
      setValue,
      config,
      animState,
      scrollMaxVal = conf.scrollMaxVal, // eslint-disable-line good-practices/no-single-usage-variable
      crispY,
      crispX,
      errorPath,
      errorValPos,
      errorValuePosFactor,
      errorValueArr,
      errorValueObj,
      errorValue,
      errorStartPos,
      errorLen,
      errorBarWidth,
      halfErrorBarW,
      groupId,
      errorLineElem,
      isNegative,
      barXpos,
      barYpos,
      barWidth,
      barHeight,
      errorStartValue,
      trackerConfig,
      trackerTolerance,
      errorTrackerConfig,
      animationManager = dataSet.getFromEnv('animationManager');

    // Loop through each data points
    for (i = conf.scrollMinVal; i < scrollMaxVal; i++) {
      dataObj = dataSet.components.data[i];
      if (!dataObj) {
        continue;
      }
      trackerConfig = dataObj.trackerConfig;
      errorTrackerConfig = dataObj.errorTrackerConfig = {};
      errorTrackerConfig.errorTrackerArr = [];
      config = dataObj && dataObj.config;
      setValue = config && config.setValue;
      // If plot value is found "null", continue the loop to next iteration.
      if (dataObj === UNDEF) {
        continue;
      } else if (dataObj && ((setValue === UNDEF || setValue === null) || (config.errorValue === BLANKSTRING ||
        config.errorValue === UNDEF || (config.errorValue === null && config.positiveErrorValue === null &&
        config.negativeErrorValue === null)))) {
        // hide error bars
        errorLen = dataObj.graphics.error && dataObj.graphics.error.length;
        for (k = 0; k < errorLen; k++) {
          if (dataObj.graphics.error && dataObj.graphics.error[k]) {
            animationManager.setAnimation({
              el: dataObj.graphics.error[k],
              label: 'path',
              callback: dataSet.drawCallBackFn('disappearing')
            });
            dataObj.graphics.error[k].shadow({ opacity: 0 });
          }
        }
        continue;
      }

      dataObj.errorBar && (delete dataObj.errorBar);

      errorValueArr = config.errorValueArr;
      errorTrackerConfig.errorLen = errorLen = errorValueArr.length;

      !dataObj.graphics.error && (dataObj.graphics.error = []);

      groupId = dataSet.getJSONIndex() + '_' + i;

      setLink = config.setLink;

      isNegative = (setValue < 0);

      barXpos = dataObj._xPos;
      barYpos = dataObj._yPos;
      barWidth = dataObj._width;
      barHeight = dataObj._height;

      yPos = isNegative ? (barYpos + barHeight) : barYpos;
      xPos = barXpos + (barWidth / 2);

      dataObj.errorBar || (dataObj.errorBar = []);

      // Loop through errorValue array
      while (errorLen--) {
        errorLineElem = null;

        errorTrackerConfig.errorTrackerArr[errorLen] = {};

        errorValueObj = errorValueArr[errorLen];
        errorTrackerConfig.errorTrackerArr[errorLen].tooltext = errorValueObj.tooltext;
        errorStartValue = errorValueObj.errorStartValue;
        errorStartPos = !isNaN(errorStartValue)
          ? yAxis.getPixel(errorStartValue) : yPos;
        errorValue = errorValueObj.errorValue;
        if (errorValue === null || isNaN(errorValue)) {
          if (dataObj.graphics.error && dataObj.graphics.error[errorLen]) {
            animationManager.setAnimation({
              el: dataObj.graphics.error[errorLen],
              label: 'path',
              doNotRemove: true,
              callback: dataSet.drawCallBackFn('disappearing')
            }).shadow({ opacity: 0 });
          }

          continue;
        }
        errorBarWidth = barWidth * (conf.errorBarWidthPercent / 100);
        halfErrorBarW = errorBarWidth / 2;

        errorValuePosFactor = visible ? -1 : 0;
        // Vertical Error drawing
        errorValPos = yAxis.getPixel(yAxis.getValue(!isNaN(errorStartValue) ? errorStartPos : barYpos) +
          (errorValue * errorValuePosFactor), { wrtVisible: true });
        (isNegative) && (errorValPos = errorValPos + barHeight);
        crispY = errorValPos;
        crispX = xPos;
        errorBarThickness = pluckNumber(errorValueObj.errorBarThickness, errorBarThickness);
        trackerTolerance = errorBarThickness > 5 ? (errorBarThickness / 2) : 2.5;
        crispY = Math.round(errorValPos) +
                            (errorBarThickness % 2 / 2);
        crispX = Math.round(xPos) +
                            (errorBarThickness % 2 / 2);
        dataObj.errorBar[errorLen] || (dataObj.errorBar[errorLen] = []);
        if (errorValueObj.errorEdgeBar) {
          errorPath = [
            M, crispX - halfErrorBarW, crispY,
            H, (crispX + halfErrorBarW)
          ];
          dataObj.errorBar[errorLen][1] = {
            _xPos: crispX - halfErrorBarW - trackerTolerance,
            _yPos: crispY - trackerTolerance,
            _height: 2 * trackerTolerance,
            _width: 2 * (halfErrorBarW + trackerTolerance),
            _toolText: errorValueObj.tooltext
          };
        } else {
          errorPath = [
            M, crispX, errorStartPos,
            V, crispY
          ];
          dataObj.errorBar[errorLen][0] = {
            _xPos: crispX - trackerTolerance,
            _yPos: crispY < errorStartPos ? crispY : errorStartPos,
            _height: Math.abs(errorStartPos - crispY),
            _width: 2 * trackerTolerance,
            _toolText: errorValueObj.tooltext
          };
        }
        errorBarColor = pluck(errorValueObj.errorBarColor, errorBarColor);
        attr = {
          path: errorPath,
          stroke: errorBarColor,
          'stroke-width': errorBarThickness,
          'cursor': setLink ? POINTER : BLANKSTRING,
          'stroke-linecap': ROUND
        };
        animState = !dataObj.graphics.error[errorLen] && visible ? 'appearing' : visible ? 'updating' : 'disappearing';
        errorLineElem = dataObj.graphics.error[errorLen] = animationManager.setAnimation({
          el: dataObj.graphics.error[errorLen] || 'path',
          container: dataSet.getContainer('errorPlotGroup'),
          component: dataSet,
          attr: attr,
          label: 'path',
          state: animState,
          callback: dataSet.drawCallBackFn(animState)
        }).shadow({ opacity: conf.shadowOpacity }, dataSet.getContainer('errorShadowGroup'));

        dataSet.getFromEnv('chartConfig').enablemousetracking && errorLineElem
          .data(GROUPID, groupId)
          .data(EVENTARGS, trackerConfig.eventArgs);
      }

      if (!config.notHalfErrorBar) {
        for (k = 2; k < 4; k++) {
          dataObj.graphics.error && dataObj.graphics.error[k] && animationManager.setAnimation({
            el: dataObj.graphics.error[k],
            label: 'path',
            doNotRemove: true,
            callback: dataSet.drawCallBackFn('disappearing')
          }).shadow({ opacity: 0 });
        }
      }
    }
  }
  /**
   * This method handles all mouse events of an dataset.
   * @param {String} eventType name of the event
   * @param {number} plotIndex index of the plot where this event has been occured
   * @param {Event} originalEvent reference of the original mouse event
   */
  _firePlotEvent (eventType, plotIndex, e) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      data = dataset.components.data[plotIndex],
      setElement = data.graphics.element,
      labelElement = data.graphics.label,
      errorBarHovered = data.errorBarHovered,
      setLink = data.config.setLink;

    if (setElement) {
      switch (eventType) {
        case 'fc-mouseover' :
          dataset._decideTooltipType(plotIndex, e);
          _rolloverResponseSetter(chart, data, e, this);
          if (setLink) {
            setElement.css({ 'cursor': POINTER });
            // labelElement is undefined in dataset graphics so checking for labelElement added
            labelElement && (labelElement.css({ 'cursor': POINTER }));
          }
          break;
        case 'fc-mouseout' :
          dataset.getFromEnv('toolTipController').hide(dataset.config.currentToolTip);
          _rolloutResponseSetter(chart, data, e, this);
          if (setLink) {
            setElement.css({ 'cursor': DEFAULT_CURSOR });
            // labelElement is undefined in dataset graphics so checking for labelElement added
            labelElement && (labelElement.css({ 'cursor': DEFAULT_CURSOR }));
          }
          break;
        case 'fc-click' :
          chart.plotEventHandler(setElement, e);
          break;
        case 'fc-mousemove' :
          dataset._decideTooltipType(plotIndex, e);
          if (errorBarHovered && !data._isRollover) {
            setElement.showHoverEffect !== 0 && setElement.attr(setElement.getData().setRolloutAttr);
            data._isRollover = true;
            data._isRollout = false;
          } else if (!errorBarHovered && !data._isRollout) {
            setElement.showHoverEffect !== 0 &&
                                 setElement.attr(setElement.getData().setRolloverAttr);
            data._isRollover = false;
            data._isRollout = true;
          }
      }
    }
  }
  // Helper function of _checkPointerOverPlot().
  _checkPointerOverErrorBar (pX, chartX, chartY) {
    var dataStore = this.components.data,
      pointObj = dataStore[pX],
      hovered,
      errorBarArr,
      errorBarCompArr,
      len,
      errorBarCompLen,
      toolText,
      xPos,
      yPos,
      height,
      width;

    if (!pointObj) {
      return;
    }

    errorBarArr = pointObj.errorBar;

    if (!errorBarArr) {
      return;
    }

    len = errorBarArr && errorBarArr.length;
    while (len--) {
      errorBarCompArr = errorBarArr[len];
      errorBarCompLen = errorBarCompArr && errorBarCompArr.length;
      while (errorBarCompLen--) {
        if (!(errorBarCompArr[errorBarCompLen] && errorBarCompArr[errorBarCompLen]._xPos)) {
          continue;
        }
        xPos = errorBarCompArr[errorBarCompLen]._xPos;
        yPos = errorBarCompArr[errorBarCompLen]._yPos;
        height = errorBarCompArr[errorBarCompLen]._height;
        width = errorBarCompArr[errorBarCompLen]._width;
        toolText = errorBarCompArr[errorBarCompLen]._toolText;

        hovered = chartX >= xPos && chartX <= xPos + width &&
                        chartY >= yPos && chartY <= yPos + height;

        if (hovered) {
          return {
            pointIndex: pX,
            hovered: hovered,
            pointObj: dataStore[pX],
            toolText: toolText
          };
        }
      }
    }
  }
  // Helper function of _getHoverPlot()
  _checkPointerOverPlot (pX, chartX, chartY) {
    var dataSet = this,
      data = dataSet.components.data[pX],
      config = data && data.config,
      tooltipValueAtEnd,
      hoverInfo;

    if (!data) {
      return;
    }
    tooltipValueAtEnd = (!dataSet.config.JSONData.plottooltext && !dataSet.getFromEnv('chart-attrib').plottooltext) ? config.toolTipValue : BLANKSTRING; // eslint-disable-line good-practices/no-single-usage-variable
    hoverInfo = dataSet._checkPointerOverErrorBar(pX, chartX, chartY);
    if (hoverInfo) {
      data.errorBarHovered = true;
      config.finalTooltext = hoverInfo.toolText;
    } else {
      hoverInfo = dataSet._checkPointerOverColumn(pX, chartX, chartY);
      data.errorBarHovered = false;

      hoverInfo && (config.finalTooltext = (config.toolText !== false) &&
                                            (config.toolText + tooltipValueAtEnd));
    }

    return hoverInfo;
  }
  /**
         * Function that retunr the nearest plot details
         * @param {number} x x-axis position of the mouse cordinate
         * @param {number} y y-axis position of the mouse cordinate
         * @return {object} return an object with details of nearest polt and whether it is hovered or not
         */
  _getHoveredPlot (chartX, chartY) {
    var dataset = this,
      x,
      pX;

    x = dataset.getFromEnv('xAxis').getValue(chartX);
    pX = Math.round(x);

    // Checking for overlap between two cosecutive column plots along x-axis
    return (pX - x > 0 ? dataset._checkPointerOverPlot(pX, chartX, chartY) ||
                dataset._checkPointerOverPlot(pX - 1, chartX, chartY)
      : dataset._checkPointerOverPlot(pX + 1, chartX, chartY) ||
                        dataset._checkPointerOverPlot(pX, chartX, chartY));
  }
  // Function to remove a data from a dataset during real time update.
  removePlots () {
    var dataSet = this,
      components = dataSet.components,
      removeDataArr = components.removeDataArr,
      pool = components.pool || (components.pool = {
        element: [],
        hotElement: [],
        label: []
      }),
      len = removeDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      removeData,
      graphics,
      i,
      k;

    for (i = 0; i < len; i++) {
      removeData = removeDataArr[0];
      removeDataArr.splice(0, 1);
      // In case of non existing data plot continue;
      if (!removeData || !removeData.graphics) {
        continue;
      }

      graphics = removeData.graphics;

      graphics.element && graphics.element.hide() && graphics.element.shadow({ opacity: 0 });
      for (k = 0; k < 4; k++) {
        if (graphics.error && graphics.error[k]) {
          dataSet.getFromEnv('animationManager').setAnimation({
            el: graphics.error[k],
            label: 'path'
          });
        }
      }

      // Storing the graphic elements for reuse.
      removeData.graphics.element && (pool.element = pool.element.concat(removeData.graphics.element));
      removeData.graphics.hotElement && (pool.hotElement = pool.hotElement.concat(removeData.graphics
        .hotElement));
      removeData.graphics.label && (pool.label = pool.label.concat(removeData.graphics.label));
    }
    components.pool = pool;
  }
}
removePlots = ErrorBar2DDataset.prototype.removePlots;
_getHoveredPlot = ErrorBar2DDataset.prototype._getHoveredPlot;
_firePlotEvent = ErrorBar2DDataset.prototype._firePlotEvent;
_checkPointerOverPlot = ErrorBar2DDataset.prototype._checkPointerOverPlot;
_checkPointerOverErrorBar = ErrorBar2DDataset.prototype._checkPointerOverErrorBar;
export { _getHoveredPlot, removePlots, _rolloverResponseSetter, _rolloutResponseSetter, _firePlotEvent, _checkPointerOverErrorBar,
  _checkPointerOverPlot };
export default ErrorBar2DDataset;
